import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

const DICT = {
  ar: {
    // chrome
    tagline: "جودة من أرضنا", brand: "سهول جنين",
    nav_palestine: "فلسطين أولاً", nav_oliveoil: "زيت الزيتون", nav_store: "المتجر", nav_basket: "ابنِ سلتك",
    nav_cook: "ماذا أطبخ؟", nav_box: "صندوق فلسطين", nav_heritage: "من تراثنا",
    nav_nutrition: "الجدول الغذائي", nav_compare: "قارن المنتجات",
    section_shop: "تسوّق", section_discover: "اكتشف",
    search_ph: "ابحث... مثال: زيت", search_full: "ابحث عن منتج...",
    login: "تسجيل الدخول", my_account: "حسابي",
    d_palestine: "المنتجات الفلسطينية", d_oliveoil: "القسم الأبرز — من جبال نابلس", d_store: "جميع المنتجات والتصنيفات", d_basket: "سلة مقترحة تناسبك",
    d_cook: "وصفات من مكوّناتك", d_nutrition: "جدول أسبوعي مخصص", d_box: "افتح واكتشف",
    d_compare: "جنباً إلى جنب", d_heritage: "حكايات من الأرض",
    // hero
    hero_title1: "من أرض فلسطين...", hero_title2: "إلى مائدتك",
    hero_sub: "منتجات فلسطينية أصيلة، مختارة بعناية من الأرض التي صنعت الحكاية.",
    hero_cta1: "اكتشف زيت الزيتون", hero_cta2: "استكشف جميع المنتجات",
    trust1: "منتجات فلسطينية", trust2: "منتجات طبيعية", trust3: "شحن إلى بابك", trust4: "مختارة بعناية",
    // sections
    cat_eyebrow: "تسوّق حسب النوع", cat_title: "تصنيفاتنا حسب نوع المنتج",
    cat_desc: "نرتّب المتجر حسب نوع المنتج وطبيعته — يتصدّره زيت الزيتون من جبال نابلس.",
    cat_featured: "القسم الأبرز",
    pal_eyebrow: "مختارة بعناية", pal_title: "منتجاتنا المختارة",
    pal_desc: "أصناف أصيلة من زيت الزيتون والزعتر والعسل والمخللات والصابون النابلسي.",
    view_all: "عرض الكل", season_title: "من موسم الأرض",
    season_desc: "قسم يتغيّر مع الفصول ليقدّم لك ما هو في موسمه الآن.",
    table_eyebrow: "تجربة بصرية", table_title: "المائدة الفلسطينية", table_desc: "اضغط على أي عنصر في المائدة لتكتشف المنتج خلفه.",
    discover_product: "اكتشف المنتج",
    land_eyebrow: "المصدر الجغرافي", land_title: "من تضاريس الأرض الفلسطينية",
    land_desc: "المصدر الجغرافي عندنا وسمٌ للأصالة وفلترٌ للبحث — لا قسمٌ مستقل. تصفّح المنتجات حسب تضاريسها الأصيلة.",
    source_featured: "المصدر الرئيسي للزيت", view_source_products: "عرض منتجات هذا المصدر",
    terrains_title: "تضاريس أخرى", terrains_desc: "جبال وتلال فلسطينية تحمل منتجاتها الأصيلة.",
    terrains_note: "ملاحظة: المحافظة أو المنطقة لا تُعرض كقسم مستقل؛ إنما كوسم جغرافي داخل المنتج ووسيلة تصفية فقط.",
    primary_identity: "الهوية الأساسية", no_regions: "لا توجد مناطق بمنتجات متوفرة بعد.", view_country: "عرض منتجات",
    basket_title: "ابنِ سلتك الفلسطينية", basket_desc: "اختر نوع السلة، ودع الموقع يقترح لك مزيجاً متكاملاً يمكنك تعديله.", start_now: "ابدأ الآن",
    gift_title: "هدية من فلسطين", gift_desc: "صندوق مختار بعناية لمن تحب، بميزانية تناسبك ورسالة خاصة.", pick_gift: "اختر هدية",
    heritage_eyebrow: "من تراثنا", heritage_title: "حكايات من الأرض", heritage_desc: "مقالات قصيرة موثقة عن الزيتون والزعتر والمونة والضيافة.", all_articles: "كل المقالات",
    // journey
    journey_eyebrow: "رحلة المنتج", journey_title1: "من أرض فلسطين... ", journey_title2: "إلى مائدتك",
    journey_desc: "كل منتج يمر بمحطات قبل أن يصلك. تابع الرحلة من الأرض حتى المائدة.",
    // occasions
    occ_eyebrow: "على مزاجك", occ_title: "اكتشف حسب المناسبة",
    occ_desc: "اختر المناسبة ونعرض لك منتجات مناسبة من تشكيلتنا الفعلية.",
    occ_empty: "لا توجد منتجات مطابقة لهذه المناسبة حالياً.",
    // states
    error_generic: "حدث خطأ أثناء تحميل البيانات.", retry: "إعادة المحاولة",
    no_products: "لا توجد منتجات متوفرة حالياً.",
    // search
    search_hint: "ابحث بالاسم، المكوّن، المنطقة... مثال: زيت زيتون فلسطيني",
    search_recent: "عمليات بحث سابقة", search_categories: "تصفّح التصنيفات",
    search_no_results: "لا توجد نتائج مطابقة لبحثك.", search_view_all: "عرض كل النتائج",
    // mini cart
    mini_added: "أُضيف إلى سلتك", mini_checkout: "إتمام الشراء",
    mini_continue: "متابعة التسوق", mini_view_cart: "عرض السلة", subtotal: "الإجمالي الفرعي",
    // country page
    products_count: "منتج", regions: "المناطق", seasons: "المواسم", country_products: "منتجات",
    // footer
    f_shop: "تسوّق", f_discover: "اكتشف", f_why: "لماذا سهول جنين؟",
    f_desc: "من أرض فلسطين... إلى مائدتك. منتجات أصيلة مختارة بعناية من الأرض التي صنعت الحكاية.",
    f_rights: "جميع الحقوق محفوظة.", f_dev: "هذه نسخة تطويرية — بعض البيانات تجريبية.",
    add_to_cart: "أضف إلى السلة", bestseller: "الأكثر طلباً", new: "جديد", organic: "عضوي موثّق",
  },
  en: {
    tagline: "Quality from our land", brand: "Jenin Suhool",
    nav_palestine: "Palestine First", nav_oliveoil: "Olive Oil", nav_store: "Store", nav_basket: "Build a Basket",
    nav_cook: "What to Cook?", nav_box: "Palestine Box", nav_heritage: "Our Heritage",
    nav_nutrition: "Meal Plan", nav_compare: "Compare Products",
    section_shop: "Shop", section_discover: "Discover",
    search_ph: "Search... e.g. oil", search_full: "Search for a product...",
    login: "Sign In", my_account: "My Account",
    d_palestine: "Palestinian products", d_oliveoil: "Our flagship — from Nablus Mountains", d_store: "All products & categories", d_basket: "A curated basket for you",
    d_cook: "Recipes from your ingredients", d_nutrition: "Custom weekly plan", d_box: "Open & discover",
    d_compare: "Side by side", d_heritage: "Stories from the land",
    hero_title1: "From the land of Palestine...", hero_title2: "to your table",
    hero_sub: "Authentic Palestinian products, carefully selected from the land that made the story.",
    hero_cta1: "Discover Olive Oil", hero_cta2: "Explore all products",
    trust1: "Palestinian products", trust2: "Natural products", trust3: "Shipped to your door", trust4: "Carefully selected",
    cat_eyebrow: "Shop by type", cat_title: "Categories by product type",
    cat_desc: "Our store is organised by product type — led by olive oil from the Nablus Mountains.",
    cat_featured: "Flagship",
    pal_eyebrow: "Carefully selected", pal_title: "Our Selection",
    pal_desc: "Authentic olive oil, zaatar, honey, pickles and Nabulsi soap.",
    view_all: "View all", season_title: "From the Land's Season",
    season_desc: "A section that changes with the seasons to bring you what's in season now.",
    table_eyebrow: "Visual experience", table_title: "The Palestinian Table", table_desc: "Tap any item on the table to discover the product behind it.",
    discover_product: "Discover product",
    land_eyebrow: "Geographic source", land_title: "From the Palestinian terrains",
    land_desc: "Here the geographic source is a tag of authenticity and a search filter — never a standalone section. Browse by authentic terrain.",
    source_featured: "Primary source for oil", view_source_products: "View this source's products",
    terrains_title: "Other terrains", terrains_desc: "Palestinian mountains and hills carrying their authentic products.",
    terrains_note: "Note: a province or city is never shown as a standalone section; only as a geographic tag inside products and a filter.",
    primary_identity: "Core identity", no_regions: "No regions with products yet.", view_country: "View products of",
    basket_title: "Build Your Palestinian Basket", basket_desc: "Choose a basket type and let us suggest a complete mix you can edit.", start_now: "Start now",
    gift_title: "A Gift from Palestine", gift_desc: "A carefully chosen box for a loved one, within your budget and with a personal note.", pick_gift: "Pick a gift",
    heritage_eyebrow: "Our Heritage", heritage_title: "Stories from the Land", heritage_desc: "Short, sourced articles on olives, zaatar, pantry and hospitality.", all_articles: "All articles",
    journey_eyebrow: "The Product's Journey", journey_title1: "From the land of Palestine... ", journey_title2: "to your table",
    journey_desc: "Every product passes through stations before it reaches you. Follow the journey from land to table.",
    occ_eyebrow: "Your mood", occ_title: "Discover by Occasion",
    occ_desc: "Pick an occasion and we'll show matching products from our actual catalog.",
    occ_empty: "No products match this occasion right now.",
    error_generic: "Something went wrong while loading.", retry: "Try again",
    no_products: "No products available right now.",
    search_hint: "Search by name, ingredient, region... e.g. Palestinian olive oil",
    search_recent: "Recent searches", search_categories: "Browse categories",
    search_no_results: "No results match your search.", search_view_all: "View all results",
    mini_added: "Added to your basket", mini_checkout: "Checkout",
    mini_continue: "Continue shopping", mini_view_cart: "View cart", subtotal: "Subtotal",
    products_count: "products", regions: "Regions", seasons: "Seasons", country_products: "Products of",
    f_shop: "Shop", f_discover: "Discover", f_why: "Why Jenin Suhool?",
    f_desc: "From the land of Palestine... to your table. Authentic products carefully selected from the land that made the story.",
    f_rights: "All rights reserved.", f_dev: "This is a development build — some data is demo.",
    add_to_cart: "Add to cart", bestseller: "Bestseller", new: "New", organic: "Certified organic",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("suhool_lang") || "ar");

  useEffect(() => {
    localStorage.setItem("suhool_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.ar[key] || key, [lang]);
  const toggle = () => setLang((l) => (l === "ar" ? "en" : "ar"));
  // pick localized field from a product/object: nameFor(obj,'name') -> name_en or name_ar
  const L = useCallback((obj, base) => {
    if (!obj) return "";
    const en = obj[`${base}_en`];
    return lang === "en" && en ? en : (obj[`${base}_ar`] ?? obj[base] ?? "");
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, toggle, setLang, L }}>
      {children}
    </LanguageContext.Provider>
  );
}
